import { initialState, initialStateByModule } from './state'

const RESET_VALIDATE_STEPS = 'resetValidateSteps'
const CHANGE_VALIDATE_STEP_PERSONAL_DATA = 'changeValidateStepPersonalData'
const CHANGE_VALIDATE_STEP_ADDRESS = 'changeValidateStepAddress'

const state = initialStateByModule('validatedSteps')

const mutations = {
  [RESET_VALIDATE_STEPS] (state) {
    const initState = initialState.validatedSteps
    Object.keys(initState).forEach(key => {
      state[key] = initState[key]
    })
  },
  [CHANGE_VALIDATE_STEP_PERSONAL_DATA] (state, payload) {
    state.personalData = payload
  },
  [CHANGE_VALIDATE_STEP_ADDRESS] (state, payload) {
    state.address = payload
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
